/**
 * Project number of the dev GCP project (`public-pulse-471909`,
 * infra/cells/au-develop.yaml). The pilot API origin is accepted only as
 * `https://core-api-<this number>.australia-southeast1.run.app`, because the
 * browser sends the user's access token there. Null keeps the pilot off for
 * any https origin. Verified with `gcloud projects describe public-pulse-471909`
 * on 2026-10-03.
 */
export const DEV_GCP_PROJECT_NUMBER: string | null = '628951711203';
